import { IMobile } from 'services/patientsApi';
import { api, VERSION } from 'services/api';
import { IAddress } from '../constants';
import { IUserResponse } from './type';

export interface ISignedURLRequest {
  fileName: any;
  mimeType: any;
  folderName: string;
}

export interface IPersonalDetails {
  firstName: string;
  lastName: string;
  password: string;
  email: {
    email: string;
  };
  mobile: IMobile;
}

export interface ILoginRequest {
  email: string;
  password: string;
  remember?: boolean | null;
}

type TClinicItem = {
  clinicName: string;
  address: {
    formattedAddress: string;
    postCode?: string;
    state?: string;
  };
  scannerAvailable: 'Yes' | 'No';
};
export interface IDentistRegisterPayload {
  type: 'dentist';
  referredCode?: string;
  personalDetails: {
    firstName: string;
    lastName: string;
    password: string;
    dob: string;
    email: {
      email: string;
    };
    mobile: IMobile;
    gdcNumber: string;
    country: string;
  };
  exp: {
    practicesYear: number;
    totalClearAlignerCases: string;
  };
  clinics: TClinicItem[];
}

export interface IDesignerRegisterRequest {
  type: string;
  personalDetails: IPersonalDetails;
  business: {
    address: IAddress;
  };
  bankDetails: any;
  profilePic: string;
  designLabName: string;
}

export interface IManufacturerRequest {
  personalDetails?: any;
  type: string;
  profilePic?: string;
  business?: any;
}

export interface ISpecialistRequest {
  personalDetails?: any;
  type: string;
  profilePic?: string;
  business?: any;
}

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<IUserResponse, ILoginRequest>({
      query: (credentials) => ({
        url: `/user/${VERSION}/login`,
        method: 'POST',
        body: credentials,
      }),
    }),
    register: builder.mutation<
      any,
      IDentistRegisterPayload | IDesignerRegisterRequest | IManufacturerRequest | ISpecialistRequest
    >({
      query: (credentials: any) => ({
        url: `/user/${VERSION}/register`,
        method: 'POST',
        body: credentials,
      }),
    }),
    verifyResetPasswordToken: builder.mutation<any, any>({
      query: (credentials: any) => ({
        url: `/user/${VERSION}/password/reset/verify`,
        method: 'POST',
        body: credentials,
      }),
    }),
    resetPassword: builder.mutation<
      any,
      IDentistRegisterPayload | IDesignerRegisterRequest | IManufacturerRequest | ISpecialistRequest
    >({
      query: (credentials: any) => ({
        url: `/user/${VERSION}/password/reset`,
        method: 'POST',
        body: credentials,
      }),
    }),
    getProfileSignedUrl: builder.mutation<any, ISignedURLRequest>({
      query: (credentials) => ({
        url: `/user/${VERSION}/signed-url`,
        method: 'POST',
        body: credentials,
      }),
    }),
    forgotPassword: builder.mutation<
      any,
      IDentistRegisterPayload | IDesignerRegisterRequest | IManufacturerRequest | ISpecialistRequest
    >({
      query: (credentials: any) => ({
        url: `/user/${VERSION}/password/token`,
        method: 'POST',
        body: credentials,
      }),
    }),
    verifyEmail: builder.mutation<any, string>({
      query: (id) => ({
        url: `/user/${VERSION}/verify?id=${id}`,
        method: 'GET',
      }),
    }),
    remindDentistJoinUs: builder.mutation<any, { email: string }>({
      query: (payload) => ({
        url: `/user/${VERSION}/dentist-reminders`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useVerifyResetPasswordTokenMutation,
  useResetPasswordMutation,
  useGetProfileSignedUrlMutation,
  useForgotPasswordMutation,
  useVerifyEmailMutation,
  useRemindDentistJoinUsMutation,
} = authApi;
